import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { RadioItemProps } from 'src/components/primitives/RadioGroup/types';
import { getRadioItemCardClassName } from 'src/components/primitives/RadioGroup/utils';
import { cm } from 'src/utils/classNames';

export default function RadioItemCard<T extends string>({
	id,
	value,
	className,
	disabled,
	size,
	label,
	subLabel,
	rightSlot,
	layout = 'inline',
	dataTestId,
	...rest
}: RadioItemProps<T>) {
	const layoutClassName = {
		inline: 'justify-center',
		stacked: 'flex-col items-start gap-y-sm justify-start h-auto py-sm',
		horizontal: 'w-full justify-between',
	}[layout];

	const content = {
		inline: label,
		stacked: (
			<>
				<span className="text-text-default">{label}</span>
				{subLabel && (
					<span className="text-left typo-body-2xs text-text-secondary transition-colors [[data-state=checked]_&]:text-text-default">
						{subLabel}
					</span>
				)}
			</>
		),
		horizontal: (
			<>
				<span>{label}</span>
				{rightSlot}
			</>
		),
	}[layout];

	return (
		<RadixRadioGroup.Item
			id={id}
			value={value}
			disabled={disabled}
			className={cm(
				getRadioItemCardClassName({ size, disabled, className }),
				layoutClassName
			)}
			data-testid={dataTestId}
			{...rest}
		>
			{content}
		</RadixRadioGroup.Item>
	);
}
